/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import FileSettlement from '../views/file-settlement/FileSettlement.vue';
import { setBreadcrumb } from './index';

const fileSettlementRoute = {
  path: '/report-settlement',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report Settlement',
        appBarTitle: 'Report Settlement',
        breadcrumbs: () => [
          setBreadcrumb('Report Settlement', '/report-settlement', true),
          setBreadcrumb('List Report Settlement', '/report-settlement'),
        ],
      },
      component: FileSettlement,
      name: 'FileSettlement',
    },
  ],

  meta: {
    title: 'BNI QRIS - File Settlement',
    appBarTitle: 'File Settlement',
  },
  component: Parent,
};

export default fileSettlementRoute;
